import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from './form-group';
import ValueViewer from './value-viewer';
import humanize from 'underscore.string/humanize';
import underscored from 'underscore.string/underscored';


export default class ReadOnlyInput extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.node.isRequired,
    value: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    placeholder: 'Not available',
    children: '',
    value: ''
  };

  render() {
    const {name, label, children, value, placeholder} = this.props;
    const _name = underscored(name);

    return (
      <FormGroup>
        <label htmlFor={_name}>{label ? label : humanize(name)}: </label>
        <ValueViewer
         readOnly={true}
         emptyText={placeholder}>{children || value}</ValueViewer>
      </FormGroup>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/read-only-input.js